<div>
    <div class="refresh">
        <app-document-editor-menu [editor]="editor" [toolbar]="toolbar"></app-document-editor-menu>
        <button (click)="reset()" class="fas fa-undo">
        </button>
    </div>
    <ngx-editor [editor]="editor" [(ngModel)]="delivery.section.value" (ngModelChange)="onEditorChange($event)">
    </ngx-editor>
</div>
